var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[_c('img',{attrs:{"src":require("../assets/nodata.jpg"),"alt":""}}),_c('div',{staticClass:"txt"},[_vm._v(_vm._s(_vm.langSet=='cn'?'暂无数据':'No Data'))])])}
var staticRenderFns = []

export { render, staticRenderFns }